// extracted by mini-css-extract-plugin
export default {"root":"EmailForm_root__mB1NN","form":"EmailForm_form__5bdf4","after":"EmailForm_after__LAZcc"};